<template>
  <v-card variant="tonal" class="mb-5">
    <v-card-title :style="{ color: appStyle.title_text_color }">
      <v-icon class="mx-3 my-1" size="small" :icon="mdiInformation" />
      {{ $t('mission-planning.info.documents.title') }}
    </v-card-title>

    <v-divider />

    <v-card-text
      v-if="documentsList?.length"
      v-for="item in documentsList"
      :key="item.id"
      class="pa-0"
    >
      <a :href="item.url" class="d-block pa-3 ma-0" target="_blank">
        <v-icon class="ml-3 mr-1 ma-0" size="small" :icon="mdiFileDocumentOutline" />
        {{ item.name }}
      </a>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { mdiInformation, mdiFileDocumentOutline } from '@mdi/js'
import { useApplicationStore } from '@/stores/applicationStore'
import { computed } from 'vue'

const applicationStore = useApplicationStore()
const appStyle = computed(() => applicationStore.appStyle)

const props = defineProps({
  missionPlanning: {
    type: Object,
    required: true
  },
  pointOfSale: {
    type: Object,
    required: true,
    default: {}
  },
  configuration: {
    type: Object,
    required: true,
    default: {}
  }
})

const documentsList = computed(() => {
  const mpFiles = props.missionPlanning?.files_storages ?? []
  const posFiles = props.pointOfSale?.files_storages ?? []
  const configFiles = props.configuration?.files_storages ?? []
  const areaFiles =
    props.configuration?.catalog?.area[props.pointOfSale?.area?.id]?.files_storages ?? []
  const parentAreaFiles =
    props.configuration?.catalog?.area[props.pointOfSale?.area?.id]?.area?.files_storages ?? []
  const storeFiles =
    props.configuration?.catalog?.store[props.pointOfSale?.store?.id]?.files_storages ?? []
  const signFiles =
    props.configuration?.catalog?.sign[props.pointOfSale?.store?.sign?.id]?.files_storages ?? []

  const files = [
    ...mpFiles,
    ...posFiles,
    ...configFiles,
    ...areaFiles,
    ...parentAreaFiles,
    ...storeFiles,
    ...signFiles
  ]

  const map = new Map()
  for (const f of files) {
    if (f && f.id != null && !map.has(f.id)) {
      map.set(f.id, f)
    }
  }

  return Array.from(map.values()).sort((a, b) => Number(a.id) - Number(b.id))
})
</script>
